// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"e8b5a453","917":"4472a87c"}[chunkId] + ".chunk.js";
};